module.exports = __webpack_public_path__ + "img/transport-2.269b41a1.png";